var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideNodesWhiteBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#fff",
    stroke: "#e8eaee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "visibility_off_20dp_5F6368_FILL0_wght400_GRAD0_opsz20",
    d: "M70.409-800.275a3.765,3.765,0,0,1,.78,1.158,4.106,4.106,0,0,1,.344,1.411.789.789,0,0,1-.245.585.8.8,0,0,1-.58.241.83.83,0,0,1-.6-.241.786.786,0,0,1-.247-.585,1.835,1.835,0,0,0-.1-.849,1.993,1.993,0,0,0-.424-.677,1.7,1.7,0,0,0-.654-.424,1.877,1.877,0,0,0-.837-.092.789.789,0,0,1-.585-.245.8.8,0,0,1-.241-.58.8.8,0,0,1,.241-.585.8.8,0,0,1,.585-.241,4.165,4.165,0,0,1,1.4.333A3.722,3.722,0,0,1,70.409-800.275ZM67.68-802.5q-.383,0-.745.024a6.672,6.672,0,0,0-.725.088,1.018,1.018,0,0,1-.652-.124.8.8,0,0,1-.4-.5.793.793,0,0,1,.08-.631.681.681,0,0,1,.511-.35,9.437,9.437,0,0,1,.965-.12q.478-.035.967-.034a10.667,10.667,0,0,1,5.654,1.571,10.114,10.114,0,0,1,3.914,4.327,1.444,1.444,0,0,1,.123.353,1.811,1.811,0,0,1,.034.355,1.81,1.81,0,0,1-.034.355,2.288,2.288,0,0,1-.1.356,8.327,8.327,0,0,1-1.006,1.627,12.881,12.881,0,0,1-1.31,1.424.76.76,0,0,1-.585.206.776.776,0,0,1-.562-.3.8.8,0,0,1-.195-.608.944.944,0,0,1,.287-.581,7.8,7.8,0,0,0,1.063-1.147,8.275,8.275,0,0,0,.818-1.33,8.469,8.469,0,0,0-3.315-3.636A9.1,9.1,0,0,0,67.68-802.5Zm0,11.561a10.146,10.146,0,0,1-5.528-1.594,11.407,11.407,0,0,1-3.97-4.236,1.033,1.033,0,0,1-.147-.375,2.313,2.313,0,0,1-.034-.4,2.3,2.3,0,0,1,.034-.4,1.058,1.058,0,0,1,.149-.378,11.687,11.687,0,0,1,1.233-1.926,10.374,10.374,0,0,1,1.611-1.629l-1.72-1.72a.79.79,0,0,1-.252-.573.79.79,0,0,1,.252-.573.8.8,0,0,1,.585-.252.8.8,0,0,1,.585.252l14.405,14.405a.79.79,0,0,1,.252.573.79.79,0,0,1-.252.573.8.8,0,0,1-.585.252.8.8,0,0,1-.585-.252L71.3-791.581a10.61,10.61,0,0,1-1.787.482A10.508,10.508,0,0,1,67.68-790.939ZM62.2-800.688a12.378,12.378,0,0,0-1.491,1.411,6.747,6.747,0,0,0-1.124,1.732,8.47,8.47,0,0,0,3.315,3.636,9.1,9.1,0,0,0,4.783,1.319,8.408,8.408,0,0,0,1.172-.08q.571-.08,1.145-.218l-1.032-1.032a4.005,4.005,0,0,1-.642.172,3.649,3.649,0,0,1-.642.057,3.716,3.716,0,0,1-2.73-1.124,3.716,3.716,0,0,1-1.124-2.73,2.639,2.639,0,0,1,.08-.642q.08-.321.149-.642ZM68.781-798.646ZM66.579-796.444Z",
    transform: "translate(-55.703 808.972)",
    fill: "#2e4d7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideNodesWhiteBackground);
export default __webpack_public_path__ + "static/media/HideNodesWhiteBackground.74ba270e7f34baa73ba5280d3399d372.svg";
export { ForwardRef as ReactComponent };